import SubDistrictActions from "./actions";

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: {},
  helperSubDistrict:null,
};

function SubDistrictReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SubDistrictActions.NEW_DATA:
      return { ...state, isProcessing: true, isError: false };
    case SubDistrictActions.SHOW_DATA:
      return {
        ...state,
        isProcessing: false,
        isAuthenticated: true,
        isError: false,
        data: action.payload,
        errorMessage: {},
      };
    case SubDistrictActions.GET_HELPER_SUBDISTRICT:
      return {
        ...state,
        isError: false,
        isSuccess: false,
        onSubmit: false,
        helperSubDistrict: action.payload,
      };
    default:
      return state;
  }
}

export default SubDistrictReducer;
